angular.module('evtviewer.reading')

.constant('READINGDEFAULTS', {
    /**
     * @module evtviewer.reading
     * @ngdoc property
     * @name tooltipMaxHeight
     * @description
     * `property`
     *
     * Some info
     *
     * Default:
     * <pre>
     * tooltipMaxHeight: 170
     * </pre>
     */
    tooltipMaxHeight: 170,

    /**
     * @module evtviewer.reading
     * @ngdoc property
     * @name tooltipMaxWidth
     * @description
     * `property`
     *
     * Some info
     *
     * Default:
     * <pre>
     * tooltipMaxWidth: 200
     * </pre>
     */
    tooltipMaxWidth: 200,
    
    /**
     * @module evtviewer.reading
     * @ngdoc property
     * @name openTriggerEvent
     * @description
     * `property`
     *
     * Some info
     *
     * Default:
     * <pre>
     * openTriggerEvent: 'click'
     * </pre>
     */
    openTriggerEvent: 'click'
})

.config(['evtReadingProvider', 'configProvider', 'READINGDEFAULTS', function(evtReadingProvider, configProvider, READINGDEFAULTS) {
    var defaults = configProvider.makeDefaults('reading', READINGDEFAULTS);
    evtReadingProvider.setDefaults(defaults);
}]);